import React, { useState } from 'react';
import '../styles/pages/GarmentsPrinting.css';
import FlexPortfolio from './FlexPortfolio';
import FlexServicesSection from '../components/FlexServicesSection';
import HeroSection from '../components/HeroSection';

const GarmentsPrinting = () => {
  const [activeSection, setActiveSection] = useState(1);

  const garmentsTypes = [
    {
      id: 1,
      title: "T-Shirt Printing",
      icon: "👕",
      description: "Custom t-shirt printing services for personal and business branding. High-quality prints that last wash after wash.",
      features: [
        "Screen printing",
        "Direct-to-garment (DTG)",
        "Vibrant colors",
        "Soft feel",
        "Durable prints",
        "Custom designs"
      ],
      specifications: {
        material: "Cotton, polyester blends",
        thickness: "150-200 GSM",
        width: "S to XXL sizes",
        durability: "50+ washes",
        applications: "Promotional wear, events, branding"
      },
      image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500&h=350&fit=crop",
      color: "#ef4444",
      bestFor: ["Corporate events", "Promotional campaigns", "Team uniforms", "Custom gifts"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1560472355-536de3962603?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 2,
      title: "Cap Printing",
      icon: "🧢",
      description: "Professional cap printing for sports teams, corporate branding, and promotional items. Comfortable and stylish designs.",
      features: [
        "Embroidered printing",
        "Screen printing",
        "Adjustable fit",
        "Moisture-wicking fabric",
        "UV protection",
        "Custom logos"
      ],
      specifications: {
        material: "Cotton, polyester",
        thickness: "Standard cap fabric",
        width: "One size fits most",
        durability: "Long-lasting prints",
        applications: "Sports teams, corporate branding, events"
      },
      image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=500&h=350&fit=crop",
      color: "#8b5cf6",
      bestFor: ["Sports teams", "Corporate giveaways", "Events", "Promotional items"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921212029-bb5a28e60960?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921140401-e21688ae4309?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 3,
      title: "Garments Tag",
      icon: "🏷️",
      description: "Custom garment tags and labels for branding and identification. High-quality printing on durable materials.",
      features: [
        "Woven labels",
        "Printed tags",
        "Satin ribbons",
        "Heat-resistant",
        "Custom shapes",
        "Barcode integration"
      ],
      specifications: {
        material: "Satin, polyester, cotton",
        thickness: "Various thicknesses",
        width: "Custom sizes",
        durability: "Machine wash safe",
        applications: "Clothing labels, branding tags"
      },
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&h=350&fit=crop",
      color: "#06b6d4",
      bestFor: ["Fashion brands", "Custom clothing", "Product identification", "Branding"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921212029-bb5a28e60960?w=400&h=300&fit=crop",
        ]
      }
    }
  ];

  return (
    <div className="garments-printing-page">
      <HeroSection
        heroTitle="Garments Printing Services"
        heroSubtitle="Bring your designs to life on apparel with our professional garment printing services. From t-shirts to caps, we deliver quality and style."
        onExploreClick={() => {
          const servicesSection = document.querySelector('.services-section');
          if (servicesSection) {
            servicesSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        onGetQuoteClick={() => {
          const contactSection = document.getElementById('contact');
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      />

      <FlexServicesSection
        flexTypes={garmentsTypes}
        title="Our Premium Garments Printing Solutions"
        subtitle="Bring your designs to life on apparel with our professional garment printing services. From t-shirts to caps, we deliver quality and style."
      />

      <FlexPortfolio
        activeSection={activeSection}
        portfolioData={garmentsTypes.map(garmentType => ({
          id: garmentType.id,
          title: garmentType.title,
          icon: garmentType.icon,
          gallery: garmentType.portfolio?.gallery || []
        }))}
        title="Our Garments Printing Portfolio"
        subtitle="Explore our diverse garments printing services and see the quality that sets us apart"
      />
    </div>
  );
};

export default GarmentsPrinting;
